import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { AlertService } from '../../services/alert.service';
import { EsService } from '../../services/es.service';
import { AuthService } from '../../services/auth.service';
import { Alert } from '../../shared/models/alert.model';
import { EsSearchParams } from '../../shared/types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-search-alert',
  templateUrl: './search-alert.component.html',
  styleUrls: ['./search-alert.component.scss'],
  standalone: false
})
export class SearchAlertComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  private alertService = inject(AlertService);
  private esService = inject(EsService);
  private route = inject(ActivatedRoute);
  toast = inject(ToastComponent);


  isLoading = {
    alert: true,
    search: null,
  };
  id = '';
  days = '3';
  fragments = 100;
  showFullDocuments = false;
  alert: Alert;
  // Arrays
  esSearchParams: EsSearchParams;
  results = [];
  count = 0;
  currentContent = 'alert-results';
  menuItems = [
    { name: 'Alert results', link: 'alert-results', icon: 'search' },
  ];

  ngOnInit(): void {
    if (!this.auth.loggedIn) {
      this.router.navigate(['/login']);
      return;
    }
    this.id = this.route.snapshot.paramMap.get('id');
    this.getAlert(this.id);
  }

  getAlert(id: string): void {
    this.isLoading.alert = true;
    this.alertService.get(id)
      .pipe(finalize(() => {
        this.isLoading.alert = false;
      }))
      .subscribe({
        next: res => {
          this.alert = res;
          this.search(this.alert);
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  showFullDocumentsSwitch(): void {
    if (!this.fragments) {
      this.showFullDocuments = false;
      this.fragments = 100;
    } else {
      this.showFullDocuments = true;
      this.fragments = 0;
    }
    this.search(this.alert);
  }

  search(alert: Alert): void {
    this.isLoading.search = true;
    this.esSearchParams = {
      keyword: alert.query.keyword,
      person: alert.query.person,
      noperson: alert.query.noperson,
      source: alert.query.source,
      lang: alert.query.lang,
      party: alert.query.party,
      days: this.days,
      organ: alert.query.organ,
      commission: alert.query.commission,
      country: alert.query.country,
      page: 0,
      perPage: 50,
      fragments: this.fragments, // If 0, show complete documents
      fragmentSize: 5000 // Show longer documents
    };
    this.esService.search(this.esSearchParams)
      .pipe(finalize(() => this.isLoading.search = false))
      .subscribe({
        next: res => {
          this.results = res.results;
          this.count = res.count;
        },
        error: err => {
          this.toast.setMessage(err.error.message, 'danger');
          this.results = [];
          this.count = 0;
        },
      });
  }

}
